<template>
<a class="vlm" @click="requestCode">    
    <slot></slot>
</a>
</template>
<script>
import sdk from "./ga_sdk"
export default {
    data(){
        return {
            client_id:sdk.client_id,context:sdk.context,itp_support:sdk.itp_support,id:sdk.id,
            callback:sdk.callback
        }
    },
    created(){
        window[this.callback] = this.handleLogin;       
    },
    methods:{
        requestCode(){           
            try {
                window.ga_client.requestAccessToken();
            } catch (error) {
                console.log(error)
            }     
        },
        handleLogin(res){
            try {
                this.$alert.loading(true);
                this.$http.post(window.PASSPORTURL + "/auth/thirdInfo",{token:res.access_token,type:'google'},{headers: {"Content-Type": "application/json"}}).finally(()=>{
                    this.$alert.loading(false);
                }).then((res)=>{
                    this.$emit("thirdinfo",res);
                })
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>
